import type { PlayerModel, PlayerModelGroup } from '@/api/models/PlayerModels';
import type { MultiSelectOption } from '@/common/SearchableMultiSelectDropdown/SearchableMultiSelectDropdown';

export interface PlayerModelOption extends MultiSelectOption {
  configuration: PlayerModel;
}

const detailFields = ['club', 'loft', 'putterLevel', 'putterType'] as const;
const detailLabels = { club: 'Club', loft: 'Loft', putterLevel: 'Level', putterType: 'Type' };

export const buildPlayerModelOptions = (groups: PlayerModelGroup[]): PlayerModelOption[] => {
  const entries = groups.flatMap(({ clubType, models }) =>
    models.map((model) => ({
      configuration: { ...model, clubType },
      label: `${clubType.charAt(0).toUpperCase()}${clubType.slice(1)} - ${[model.family, model.model].filter(Boolean).join(' ')}`,
    })),
  );

  return entries.map(({ configuration, label }) => {
    const matches = entries.filter((entry) => entry.label === label);
    const differingFields = detailFields.filter((field) => new Set(matches.map((entry) => entry.configuration[field])).size > 1);
    const details = differingFields.map((field) => `${detailLabels[field]}: ${configuration[field] || 'Not specified'}`);
    return {
      value: JSON.stringify([configuration.clubType, configuration.family, configuration.model, configuration.club, configuration.loft, configuration.putterLevel, configuration.putterType]),
      label: [label, ...details].join(' · '),
      group: `${configuration.clubType.charAt(0).toUpperCase()}${configuration.clubType.slice(1)}`,
      configuration,
    };
  });
};
